import React from 'react';
import { Link } from 'react-router-dom';
const Breadcrumbs = ({ crumbs, title }) => {
  if (!crumbs || crumbs?.length <= 1) {
    return null;
  }
  return (
    <div className='breadcrumbs'>
      { title && (
        <div className='section'>
          <span className='title'>
            {title}<strong>.</strong>
          </span>
        </div>
      )}
      <div className='links'>
        {crumbs?.map(({ name, path }, key) =>
          key + 1 === crumbs.length ? (
            <span key={key}>
              {name}
            </span>
          ) : (
            <Link key={key} to={path}>
              {name}
            </Link>
          )
        )}
      </div>
    </div>
  );
};
export default Breadcrumbs;
